import React from "react";
import LoginMain from "../../components/auth/LoginMain";

const LoginPage: React.FC = () => {
  return (
    <LoginMain />
  );
}

export default LoginPage;
